import {
  hasCommissionErrors,
  salesCommissionSectionErrors,
} from './salesCommissionValidation';

const participantComplete = (form, section) => {
  const group = form.participants?.[section] || {};
  if (section === 'general_managers' && group.enabled === false) return true;
  if (!group.rows?.length) return false;
  if (section === 'optionist_brokers' && !group.report_type) return false;
  return null;
};

export const salesCommissionSectionComplete = ({ form, section, t }) => {
  if (!['company', 'installments'].includes(section)) {
    const complete = participantComplete(form, section);
    if (complete !== null) return complete;
  }
  return !hasCommissionErrors(
    salesCommissionSectionErrors({ form, section, t })
  );
};

export const salesCommissionProgressState = ({ form, sections, t }) => {
  const completedSections = sections.filter(section =>
    salesCommissionSectionComplete({ form, section, t })
  );
  const firstIncomplete = sections.find(
    section => !completedSections.includes(section)
  );
  const availableCount = firstIncomplete
    ? sections.indexOf(firstIncomplete) + 1
    : sections.length;
  return {
    availableSections: sections.slice(0, availableCount),
    completedSections,
    complete: completedSections.length === sections.length,
    firstIncomplete,
    percent: Math.round((completedSections.length * 100) / sections.length),
  };
};
